import type { GlobalState, TabArgs } from '../types'
import { selectTabState } from './tabs'
import { getCurrentTabId } from '../../util/establishMultitabRole'

export function selectCurrentGlobalSearchQuery<T extends GlobalState>(
  global: T,
  ...[tabId = getCurrentTabId()]: TabArgs<T>
) {
  return selectTabState(global, tabId).globalSearch.query
}
